/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Component, OnInit } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { EmailDetailService } from '../services/email-detail.service';
import { AggregateService } from '../services/aggregate.service';
import { EnrichService } from '../services/enrich.service';
import { SessionService } from '../services/session2.service';
import { CacheService } from '../global/ng2-cache/services/cache.service';
import { ErrorService } from '../services/error.service';
import { GlobalMessageService } from '../services/global-message.service';

//import { Animations } from '../global/animations';
import { Constants, EmailType } from '../global/constants';
import { Router, NavigationEnd } from '../../../node_modules/@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html'
  // host: { '[@routerTransition]': 'true' },
  // animations: Animations.page
})
export class HomeComponent implements OnInit {
  navigationSubscription; //used to force the component to reload; This happens when you switch accounts and are already on this view

  loadingPage: boolean = true;
  session: any;

  atLeastOne: boolean = false;

  summaryData: any = {};
  enrichHistory: any = null;
  humanHistory: any = null;

  dateRangeOptions: any = {
    minDate: '01/01/2015',
    format: 'MM/DD/YYYY',
    autoApply: true
  };

  constructor(private sessionService: SessionService,
    private cacheService: CacheService,
    private emailDetailService: EmailDetailService,
    private aggregateService: AggregateService,
    private enrichService: EnrichService,
    private errorService: ErrorService,
    private globalMessageService: GlobalMessageService,
    private constants: Constants,
    private router: Router) {

    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      // If it is a NavigationEnd event re-initalise the component
      if (e instanceof NavigationEnd) {
        this.sessionChange();
      }
    });
  }

  ngOnInit() {
    this.sessionChange();
  }

  ngOnDestroy() {
    // avoid memory leaks here by cleaning up after ourselves. If we
    // don't then we will continue to run our initialiseInvites()
    // method on every navigationEnd event.
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }

  filterDate(range: any) {
    this.dateRangeOptions.startDate = range.start;
    this.dateRangeOptions.endDate = range.end;

    if (range.numDays) {
      this.session.dashboard_filters.days = range.numDays;
      this.session.dashboard_filters.range = null;
    }
    else {
      this.session.dashboard_filters.days = 0;
      this.session.dashboard_filters.range = {
        start: range.start,
        end: range.end
      }
    }

    this.resetData();
    this.saveSession();
  }

  getTypeClass(type: string) {
    let cssClass: string = 'category-3';
    let et: EmailType =
      this.constants.emailTypes.find((et) => {
        return et.typeName == type;
      });
    if (et) {
      cssClass = et.cssClass;
    }
    return cssClass;
  }

  private sessionChange() {
    if (!this.session) {
      this.sessionService.getSession().subscribe(
        (session: any) => {
          this.session = session;
          this.initView();
        }
      )
    }
    else {
      this.initView();
    }
  }

  private initView() {
    // make sure contact filters exist for this user
    if (!this.session.dashboard_filters || !this.session.dashboard_filters.last_changed) {
      this.resetFilters();
    }

    var now = new Date();
    var lastUpdate = new Date(this.session.dashboard_filters.last_changed);
    if (now.getTime() - lastUpdate.getTime() > 900000) {
      // 900000ms = 15 minutes. Let's reset filters if it's been more than 15 minutes since they were last last changed
      this.resetFilters();
    }

    if (this.session.dashboard_filters.range) {
      // custom range is currently selected
      this.dateRangeOptions.startDate = new Date(this.session.dashboard_filters.range.start);
      this.dateRangeOptions.endDate = new Date(this.session.dashboard_filters.range.end);
    }
    else {
      // standard "time ago" is currently selected
      this.dateRangeOptions.endDate = new Date();
      this.dateRangeOptions.startDate = new Date();
      if (this.session.dashboard_filters.days > 0) {
        this.dateRangeOptions.startDate.setDate(this.dateRangeOptions.endDate.getDate() - this.session.dashboard_filters.days + 1);
      }
      else {
        // special case for "yesterday"
        this.dateRangeOptions.startDate.setDate(this.dateRangeOptions.endDate.getDate() - 1);
        this.dateRangeOptions.endDate.setDate(this.dateRangeOptions.endDate.getDate() - 1);
      }
    }
    this.resetData();
  }

  private resetData() {
    this.loadingPage = true;
    Observable.forkJoin(
      this.aggregateService.getSummary(this.dateRangeOptions.startDate, this.dateRangeOptions.endDate),
      this.emailDetailService.atLeastOne(this.session.email),
      this.enrichService.getHistory(this.dateRangeOptions.startDate, this.dateRangeOptions.endDate)
    ).subscribe(
      (result: any) => {
        this.summaryData = result[0];
        this.atLeastOne = result[1].has_one;
        this.enrichHistory = result[2];
        this.humanHistory = this.summaryData.human_trend;
        this.loadingPage = false;
      },
      error => {
        this.globalMessageService.error();
        this.errorService.log(error, 'home.component', 'resetData');
      }
    )
  }

  private saveSession() {
    this.session.dashboard_filters.last_changed = new Date();
    this.sessionService.saveSession(this.session).subscribe(
      (result: any) => {
        // Nothing
      },
      err => {
        this.errorService.log(err, 'home.component', 'saveSession');
      }
    )
  }

  private resetFilters() {
    this.session.dashboard_filters = {
      days: 30,
      range: null
    };
    this.saveSession();
  }

}



// WEBPACK FOOTER //
// ./client/app/home/home.component.ts